import { BrPartnerRelationDto } from 'hooks/queries/useFetchBrMetaDataWithRelatedPartners';
import { BrSearchDto, BrTypes } from 'types/BrTypes';
import { BusinessRelationshipLifecycle, BusinessRelationshipStatus } from 'views/CaseRedirect/CaseRedirect';

export const hasBRWithIntermediaryB2B = (businessRelations: BrSearchDto[]) => {
  const busRelLifecycles = [
    BusinessRelationshipLifecycle.OPERATING,
    BusinessRelationshipLifecycle.PROSPECTING,
    BusinessRelationshipLifecycle.ONBOARDING,
  ] as BusinessRelationshipLifecycle[];

  return (
    !!businessRelations?.length &&
    businessRelations?.some((businessRelation: BrSearchDto) => {
      return (
        businessRelation.busRelType === BrTypes.INTERMEDIARY_B2B &&
        busRelLifecycles.includes(businessRelation.busRelLifecycle as BusinessRelationshipLifecycle)
      );
    })
  );
};

export const hasBRWithInActiveStatus = (businessRelations: BrSearchDto[]) => {
  return (
    !!businessRelations?.length &&
    businessRelations?.some((businessRelation: BrSearchDto) => {
      return (
        businessRelation.busRelLifecycle === BusinessRelationshipLifecycle.CLOSED &&
        businessRelation.busRelStatus === BusinessRelationshipStatus.INACTIVE
      );
    })
  );
};

const PARTNER_ROLE_ORDER = [
  'ACCOUNT_HOLDER',
  'BENEFICIAL_OWNER',
  'POWER_OF_ATTORNEY',
  'OWNER_OF_ENJOYMENT',
  'HOLDER_OF_MANAGEMENT_POWER',
];

const getPartnerRoleRank = (role: string) => {
  const index = PARTNER_ROLE_ORDER.indexOf(role);
  return index === -1 ? PARTNER_ROLE_ORDER.length : index;
};

export const comparePartnersByRole = (a: BrPartnerRelationDto, b: BrPartnerRelationDto) => {
  const rankDiff = getPartnerRoleRank(a.partnerRole) - getPartnerRoleRank(b.partnerRole);
  if (rankDiff !== 0) return rankDiff;
  if (a.partnerRole !== b.partnerRole) return a.partnerRoleLabel.localeCompare(b.partnerRoleLabel);
  return a.partnerName.localeCompare(b.partnerName);
};
